export default "__VITE_ASSET__21ce9970__"